import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	AppTabs,
	Edit,
	Create,
	Crud,
	Show,
	trans
} from '@/router/index'


export const credentials = [
	{ 
		path: '/credentials/create',
		name: 'credentials-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'credentials',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/credentials/:id/edit',
		name: 'credentials-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'credentials',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/credentials/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 
		props: (route) => ({
			tabs: [
				{
					to: '/credentials/' + parseInt(route.params.id) + '/',
					text: 'Credenziali',
				},
			],
		}), 
		children: [
			{
				path: '',
				name: 'credentials-show', 
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'credential', next) },
				component: Show,
				meta: {
					title: 'Credenziali'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'credentials',
					modelClass: 'credential',
					activities: true,
					fileuploader: true
				}), 
			},
		]
	},
]